<div class="main-layout">
    <AppHeader />
    <main>
        <SideMenu />
        <slot></slot>
    </main>
    <AppFooter />
</div>